const addHyperLinkToFormCtas = (ctaID, privacyPolicyData) => {
    if (privacyPolicyData && privacyPolicyData.link && privacyPolicyData.color && privacyPolicyData.text) {
        const privacyPolicy = `
          <div class="cta-privacy-policy">
            <a href="${privacyPolicyData.link}" style="color:${privacyPolicyData.color}">
            ${privacyPolicyData.text}
            </a>
          </div>
          `;
        if (ctaID) {
            document.querySelector(`.cta-form[data-cta-id="${ctaID}"]`).querySelector('.form-fields .cta-button-container').insertAdjacentHTML('beforebegin', privacyPolicy);
        }
        /* Uberflip GWL OB-9125 start here */
        if (privacyPolicy) {
            const mobileTarget = document.querySelector('.full-screen-cta .form-fields .cta-button-container');
            if (mobileTarget) {
                mobileTarget.insertAdjacentHTML('beforebegin', privacyPolicy);
            }
        }
        /* Uberflip GWL OB-9125 end here */
    }
};

export { addHyperLinkToFormCtas };


// WEBPACK FOOTER //
// ./scriptPartials/form-cta-hyperlink.js